export const menuData = [
    {
        category: "HOT SERVE MENU",
        items: [
            { name: "ESPRESSO", price: "119" },
            { name: "DOPPIO", price: "129" },
            { name: "ESPRESSO TEICHNER", price: "129" },
            { name: "ESPRESSO CHOCO", price: "129" },
            { name: "CAPPUCCINO", price: "159" },
            { name: "SPICED CAPPUCCINO", price: "169" },
            { name: "HAZELNUT CAPPUCCINO", price: "189" },
            { name: "NUTTECCINO", price: "179" },
            { name: "ESPRESSO MACCHIATO", price: "159" },
            { name: "AMERICANO FRESH", price: "129" },
            { name: "MOCHA", price: "179" },
            { name: "WHITE CHOCO MOCHA", price: "179" },
        ]
    },
    {
        category: "LUXURY LATTES & SPECIALS",
        items: [
            { name: "CAFÉ LATTE", price: "169" },
            { name: "CAFÉ CINNAMON LATTE", price: "169" },
            { name: "VANILLA LATTE", price: "169" },
            { name: "MEMORY LATTE", price: "169" },
            { name: "AFFOGATO", price: "169" },
            { name: "BROWNIE AFFOGATO", price: "199" },
            { name: "BISCOFF MOCHA", price: "199" },
            { name: "HOT CHOCOLATE ESPRESSO", price: "159" },
            { name: "IRISH MOCHA", price: "159" },
            { name: "PISTACHIO LATTE", price: "179" },
            { name: "MATCHA CAFÉ LATTE", price: "199" },
            { name: "CLASSIC HOT MATCHA CAPPUCCINO", price: "199" },
        ],
        addOns: [
            { name: "ESPRESSO SHOT / VANILLA", price: "39" },
            { name: "ADD FLAVOUR (CARAMEL, HAZELNUT, IRISH)", price: "39" }
        ]
    },
    {
        category: "TEA BREW",
        items: [
            { name: "BLACK BREW", price: "69" },
            { name: "INDIAN REGULAR", price: "69" },
            { name: "MASALA BREW", price: "69" },
            { name: "GINGER BREW", price: "69" },
            { name: "GREEN TEA", price: "69" },
            { name: "HIBISCUS TEA", price: "119" },
            { name: "GINGER HONEY TEA", price: "109" },
            { name: "BLUE TEA", price: "129" },
        ]
    },
    {
        category: "HOT CHOCOLATE",
        items: [
            { name: "ORIGINAL HOT CHOCOLATE", price: "139" },
        ]
    },
    {
        category: "FILTER COFFEE",
        items: [
            { name: "INDIAN FILTERED COFFEE", price: "129" },
        ],
        addOns: [
            { name: "ESPRESSO SHOT / VANILLA", price: "39" },
            { name: "ADD FLAVOUR (CARAMEL, HAZELNUT, IRISH)", price: "39" }
        ]
    },
    {
        category: "COLD SERVE",
        items: [
            { name: "ICED ESPRESSO", price: "149" },
            { name: "ICED AMERICANO", price: "159" },
            { name: "CINNAMON ICED LATTE", price: "179" },
            { name: "ICED CARAMEL MACCHIATO", price: "179" },
            { name: "ICED MANGO MATCHA", price: "209" },
            { name: "ICE LATTE MATCHA", price: "199" },
            { name: "MATCHA FRESPRESSO", price: "199" },
            { name: "BLUE VANILLA ICED LATTE", price: "209" },
            { name: "STRAWBERRY CHOCOLATE ICED LATTE", price: "219" },
            { name: "COFFEE TARNDO", price: "249" },
        ]
    },
    {
        category: "MILK BASED COLD COFFEE",
        items: [
            { name: "REGULAR COFFEA", price: "189" },
            { name: "HAZELNUT COFFEA", price: "199" },
            { name: "IRISH COFFEA", price: "199" },
        ],
        addOns: [
            { name: "ESPRESSO SHOT / VANILLA", price: "39" },
            { name: "ADD FLAVOUR (CARAMEL, HAZELNUT, IRISH)", price: "39" }
        ]
    },
    {
        category: "COFFEE FRESPRESSO",
        items: [
            { name: "CHOCO MINT FRESPRESSO", price: "229" },
            { name: "NUTELLA FRESPRESSO", price: "229" },
            { name: "BROWNIE FRESPRESSO", price: "229" },
            { name: "BISCOFF FRESPRESSO", price: "229" },
            { name: "BANANA FRESPRESSO", price: "229" },
        ]
    },
    {
        category: "SHAKESPRESSO SHAKES",
        items: [
            { name: "CHOCO CHIPS SHAKESPRESSO", price: "209" },
            { name: "CARAMEL SHAKESPRESSO", price: "209" },
            { name: "NUTELLA SHAKESPRESSO", price: "209" },
            { name: "BROWNIE MUD PIE SHAKESPRESSO", price: "209" },
            { name: "TIRAMISU WONDER SHAKESPRESSO", price: "209" },
            { name: "BISCOFF SHAKESPRESSO", price: "209" },
            { name: "CHOCOLATE HAZELNUT SHAKE", price: "219" },
        ],
        addOns: [
            { name: "ESPRESSO SHOT / VANILLA", price: "39" },
            { name: "ADD FLAVOUR (CARAMEL, HAZELNUT, IRISH)", price: "39" }
        ]
    },
    {
        category: "MOCKTAILS",
        items: [
            { name: "WATERMELON MINT", price: "169" },
            { name: "GREEN APPLE", price: "169" },
            { name: "MANGO PUNCH", price: "169" },
            { name: "BLUE LAGOON", price: "169" },
            { name: "STRAWBERRY MINT", price: "169" },
            { name: "TRIPLE SEC", price: "169" },
            { name: "VIRGIN MOJITO", price: "169" },
            { name: "STRAWBERRY MARGARITA", price: "188" },
            { name: "VIRGIN PIÑA COLADA", price: "229" },
            { name: "VALENTINE MOCKTAIL", price: "239" },
            { name: "FRESH LEMON SODA", price: "159" },
            { name: "PINEAPPLE LEMON REFRESHER", price: "-" },
            { name: "LEMON MASALA SODA", price: "159" },
            { name: "CRANBERRY APPLE JUICE", price: "-" },
            { name: "LEMON SODA MATCHA", price: "199" },
        ],
        addOns: [
            { name: "ESPRESSO SHOT / VANILLA", price: "39" },
            { name: "ADD FLAVOUR (CARAMEL, HAZELNUT, IRISH)", price: "39" }
        ]
    },
    {
        category: "COLD SPECIAL ICED",
        items: [
            { name: "ESPRESSO TONIC SPARKLING", price: "199" },
            { name: "ICED ORANGE ESPRESSO", price: "199" },
            { name: "ICED MANGO MOCHA", price: "199" },
            { name: "ICED CRANBERRY", price: "199" },
            { name: "VIETNAMESE ICED COFFEE", price: "199" },
        ]
    },
    {
        category: "HEALTHY SHAKES",
        items: [
            { name: "BANANA AVOCADO SHAKE", price: "249" },
            { name: "BANANA STRAWBERRY SHAKE", price: "239" },
            { name: "BLUEBERRY BANANA SHAKE", price: "229" },
        ]
    },
    {
        category: "ICED TEA",
        items: [
            { name: "LEMON SHAKED ICED TEA", price: "169" },
            { name: "CRANBERRY SHAKED ICED TEA", price: "169" },
        ],
        addOns: [
            { name: "ESPRESSO SHOT / VANILLA", price: "39" },
            { name: "ADD FLAVOUR (CARAMEL, HAZELNUT, IRISH)", price: "39" }
        ]
    },
    {
        category: "THE COFFEA SANDWICH MENU - LETS GRILL",
        items: [
            { name: "THE RUNNER EXOTIC VEGGIE DELIGHT", price: "229" },
            { name: "CHUTNEY CHEESE MELT/SPICY", price: "219" },
            { name: "PANEER TAKA TAK", price: "239" },
        ]
    },
    {
        category: "GRILL CONTINUED",
        items: [
            { name: "SPINACH CORN SANDWICH", price: "239" },
            { name: "BROCCOLI CORN SANDWICH", price: "239" },
            { name: "MEXICAN GRILLED SANDWICH", price: "239" },
            { name: "CREAMY COTTAGE CHEESE SANDWICH", price: "239" },
            { name: "CHEESY CLUB CHUTNEY", price: "299" },
            { name: "TANDOORI CLUB INDIANO", price: "299" },
        ]
    },
    {
        category: "MALAI BROCCOLI",
        items: [
            { name: "MALAI BROCCOLI", price: "299" },
        ]
    },
    {
        category: "VADA PAV",
        items: [
            { name: "VADA PAV", price: "60" },
        ]
    },
    {
        category: "ITALIAN GARLIC BREAD",
        items: [
            { name: "THE ORIGINAL BUTTER", price: "169" },
            { name: "CREAMY CHEESE DELIGHT MILD/SPICY", price: "189" },
            { name: "PIZZERIA", price: "189" },
        ]
    },
    {
        category: "OPEN FACE (BROWN BREAD)",
        items: [
            { name: "CREAMY PANEER BHURJI TOASTY", price: "199" },
            { name: "GREEK VEG TOASTY", price: "199" },
        ]
    },
    {
        category: "THE COFFEA ITALIAN LANE (PASTA)",
        items: [
            { name: "RED SERVE PASTA", price: "299" },
            { name: "CREAMY WHITE SERVE PASTA", price: "309" },
            { name: "PESTO SPAGHETTI PASTA", price: "329" },
            { name: "ANGRY AGLIO SPAGHETTI", price: "299" },
            { name: "PINK BLUSH FUSILLI", price: "319" },
        ]
    },
    {
        category: "THE COFFEA MACARONI MENU",
        items: [
            { name: "YUM YUM HOT SCHEZWAN MACARONI", price: "189" },
            { name: "PERI PERI FIERY MACARONI", price: "189" },
            { name: "CHEESE CORN MACARONI", price: "229" },
            { name: "CLASSIC MAC N CHEESE", price: "229" },
        ]
    },
    {
        category: "THE COFFEA PIZZA CORNER",
        items: [
            { name: "VEG PARADISE PIZZA", price: "249" },
            { name: "FARM PUNCH PIZZA", price: "249" },
            { name: "TIKKA PANEER PIZZA TREAT", price: "269" },
            { name: "MEXICAN COW BOY PIZZA", price: "269" },
            { name: "4 IN ONE PIZZA", price: "289" },
            { name: "FIRANGIMARGHERITA PIZZA", price: "239" },
        ]
    },
    {
        category: "COFFEA MEXICAN NACHOS PLATTER",
        items: [
            { name: "CRISPY NACHOS WITH DIP", price: "259" },
            { name: "LOADED SALSA CHEESE NACHOS", price: "309" },
        ]
    },
    {
        category: "COFFEA BELGIAN FRIES",
        items: [
            { name: "NAMAK SHAMAK FRIES", price: "139" },
            { name: "PERI PERI MASALA FRIES", price: "159" },
            { name: "TANDOORI FRIES", price: "159" },
            { name: "CHEESY CHEESY FRIES", price: "209" },
            { name: "CRISPY HONEY CHILLI FRIES", price: "209" },
        ]
    },
    {
        category: "THE BURGER HOUSE",
        items: [
            { name: "VEG GRILL & CHILL BURGER", price: "129" },
            { name: "PANEER JUICY BITE BURGER", price: "159" },
        ]
    },
    {
        category: "SALAD",
        items: [
            { name: "RUSSIAN SALAD", price: "259" },
            { name: "GREEK SALAD", price: "259" },
        ]
    },
    {
        category: "WRAPS",
        items: [
            { name: "GRILL VEGGIE WRAP", price: "169" },
            { name: "PANEER FRANKIE WRAP", price: "189" },
        ]
    },
    {
        category: "SUBWAY SANDWICH",
        items: [
            { name: "BBQ PANEER SUB", price: "229" },
            { name: "THE ULTIMATE VEGGIE SUB", price: "189" },
        ]
    },
    {
        category: "FAST MORNING OPTION",
        items: [
            { name: "BUN MASKA", price: "79" },
            { name: "AVOCADO TOAST", price: "299" },
            { name: "CROISSANT SANDWICH", price: "219" },
            { name: "BUTTER CROISSANT", price: "149" },
            { name: "CHOCOLATE CROISSANT", price: "169" },
            { name: "MUSHROOM TOAST", price: "239" },
        ]
    },
    {
        category: "COFFEA BROWNIE",
        items: [
            { name: "SMOKE CHOCO BROWNIE CAKE", price: "179" },
            { name: "HAZELNUT NUTELLA BROWNIE CAKE", price: "199" },
            { name: "ORANGE CHOCOLAVA", price: "109" },
        ]
    },
    {
        category: "FLAVOURS OF COFFEA PANEER",
        items: [
            { name: "PAN FRIED TANDOORI PANEER", price: "279" },
            { name: "MAGIC MALAI PANEER", price: "289" },
            { name: "HOT SHOT CHILLI PANEER", price: "279" },
            { name: "CHILLI PANEER", price: "299" },
            { name: "SHEZWAN PANEER", price: "299" },
        ]
    },
    {
        category: "COFFEA CHEESE CAKE",
        items: [
            { name: "BISCOFF", price: "279" },
            { name: "BLUE BERRY", price: "279" },
        ]
    },
    {
        category: "MUFFIN",
        items: [
            { name: "WALNUT MUFFIN", price: "75" },
            { name: "VANILLA MUFFIN", price: "70" },
            { name: "CHERRY MUFFIN", price: "75" },
        ]
    },
    {
        category: "DONUT",
        items: [
            { name: "CHOCOLATE DONUT", price: "79" },
            { name: "WHITE CHOCOLATE DONUT", price: "79" },
        ]
    },
    {
        category: "DESSERT",
        items: [
            { name: "BROWNIE JAR", price: "199" },
            { name: "CHOCOLATE MOUSSE", price: "129" },
            { name: "TUTTI FRUIT TEA CAKE", price: "50/Pc" },
            { name: "OREO ICE CREAM", price: "159" },
            { name: "TUTTI FRUTTI ICE CREAM", price: "149" },
        ]
    }
];
